import { addDoc, collection, doc, serverTimestamp, updateDoc } from 'firebase/firestore';
import { db } from './firebase';
import { uploadIncidentMedia } from '../components/Dashboard/Incidents/Media/mediaUploadService';

export const saveFoodLogEntry = async ({
  child, user, foodLog, foodConfig, foodPresentation, mode, entryId, initialData,
}) => {
  const { foodDate, foodTime, foodTimestamp, mealType, whatWasEatenData, portion, reaction, notes } = foodLog;

  const mealText = [
    mealType,
    whatWasEatenData?.text,
  ].filter(Boolean).join(' — ');
  const requiresReview = reaction === 'Allergy concern';
  const timeZoneOffsetMinutes = -foodTimestamp.getTimezoneOffset();
  const timeZoneName = Intl.DateTimeFormat().resolvedOptions().timeZone || null;
  const docData = {
    childId: child.id,
    createdBy: user.uid,
    createdAt: serverTimestamp(),
    text: mealText || foodConfig.fallbackText,
    title: foodPresentation.title,
    titlePrefix: foodPresentation.titlePrefix,
    status: 'active',
    category: 'food',
    categoryLabel: foodPresentation.categoryLabel,
    adaptiveFoodLogLabel: foodPresentation.categoryLabel,
    adaptiveFoodLogLens: foodPresentation.lensKey,
    tags: ['food', mealType?.toLowerCase()].filter(Boolean),
    timestamp: foodTimestamp,
    timestampUtc: foodTimestamp.toISOString(),
    timestampSource: 'local-input',
    entryDate: new Date(`${foodDate}T00:00:00`).toDateString(),
    localDate: foodDate,
    localTime: foodTime,
    timeZoneOffsetMinutes,
    timeZoneName,
    authorId: user.uid,
    authorName: user.displayName || user.email?.split('@')[0] || 'User',
    authorEmail: user.email,
    source: 'food_log',
    foodDetails: {
      mealType,
      portion,
      reaction,
      requiresReview,
      reviewReason: requiresReview ? 'allergy_concern' : '',
      whatWasEaten: whatWasEatenData?.text || '',
      notes,
      adaptiveFoodLogLabel: foodPresentation.categoryLabel,
      adaptiveFoodLogLens: foodPresentation.lensKey,
      adaptiveAmountLabel: foodPresentation.amountLabel,
      adaptiveReactionLabel: foodPresentation.reactionLabel,
      adaptiveNotesLabel: foodPresentation.notesLabel,
      localDate: foodDate,
      localTime: foodTime,
      timeZoneOffsetMinutes,
      timeZoneName,
      timestampSource: 'local-input',
    },
  };

  let docRef;
  if (mode === 'edit' && (entryId || initialData?.id)) {
    const targetId = entryId || initialData?.id;
    docRef = doc(db, 'dailyLogs', targetId);
    await updateDoc(docRef, {
      ...docData,
      updatedAt: serverTimestamp(),
    });
  } else {
    docRef = await addDoc(collection(db, 'dailyLogs'), docData);
  }
  let mediaUrls = [];

  if (whatWasEatenData?.mediaFile || whatWasEatenData?.audioBlob) {
    const uploadedRichMedia = await uploadIncidentMedia(
      whatWasEatenData?.mediaFile,
      whatWasEatenData?.audioBlob,
      docRef.id,
      `dailyLogs/${docRef.id}`
    );
    mediaUrls = (uploadedRichMedia || []).map((item) => item.url).filter(Boolean);
    if (mediaUrls.length > 0) {
      await updateDoc(docRef, { mediaUrls });
    }
  }

  return docRef;
};
